<div class="upload-migration-root" *transloco="let t">
  <app-header>{{ t(labels.upload) }}</app-header>
  <app-paragraph class="upload-explanation">{{
    t(labels.uploadFunctionExplanation)
  }}</app-paragraph>
  <app-header class="title" *ngIf="!isSingleOption()">{{
    t(labels.selectDataUpload)
  }}</app-header>
  <div class="upload-container"  *ngIf="!showPortBatchProcessing">
    <div class="file-upload-area">
      <app-filter-container
        (selectFilterClick)="updateFilter($event)"
        [baseSimpleChipData]="chipContents"
        [isSingleSelection]="true"
        [filters]="this.filters"
        *ngIf="!isSingleOption()"
      ></app-filter-container>
      <app-header *ngIf="isSingleOption()">{{
        t(chipContents[0].filterType || '')
      }}</app-header>
      <app-paragraph *ngIf="showPortText">{{
        t(labels.uploadPortReportInfo)
      }}</app-paragraph>
      <app-paragraph *ngIf="showMigrationText">
        <a href="javascript:;" (click)="downloadMigrationTemplate()">{{
          t(labels.clickHereToDownload)
        }}</a>
        {{ t(labels.migrationDataspreadSheetTemplate) }}
      </app-paragraph>
      <div class="radio-area" *ngIf="dataTypeControl.value === 'POINT_CODE'">
        <div class="radio-button">
          <input
            type="radio"
            id="ink-supplies"
            name="supply-type"
            value="INK"
            [formControl]="supplyTypeControl"
          />
          <label for="ink-supplies">{{ t(labels.inkSupplies) }}</label>
        </div>
        <div class="radio-button">
          <input
            type="radio"
            id="paper-supplies"
            name="supply-type"
            value="PAPER"
            [formControl]="supplyTypeControl"
          />
          <label for="paper-supplies">{{ t(labels.paperSupplies) }}</label>
        </div>
      </div>
      <app-file-upload
        [accept]="acceptedMimeType"
        [abstractControl]="fileControl"
      ></app-file-upload>
      <app-primary-button
        (clickAction)="uploadFile()"
        [abstractControl]="formGroup"
      >
        {{ t(labels.uploadFile) }}
      </app-primary-button>
      <app-label class="upload-file-type">
        {{ t(labels.onlyUploadFilesInBeforeFormat) }}
        <span class="upload-file-type">{{ uploadFileType }}</span>
        {{ t(labels.onlyUploadFilesInAfterFormat) }}.
      </app-label>
    </div>
    <div class="queue-area">
      <app-header>{{ t(queueTitle) }}</app-header>
      <div class="upload-queue-wrapper">
        <app-upload-queue-head
          (retry)="retry($event)"
          (downloadReport)="downloadReport($event)"
          [type]="queueType"
        >
        </app-upload-queue-head>
      </div>
    </div>
  </div>
  <div
    class="port-batch-container"
    *ngIf="showPortBatchProcessing"
  >
    <div class="port-batch-filter">
      <app-filter-container
        (selectFilterClick)="updateFilter($event)"
        [baseSimpleChipData]="chipContents"
        [isSingleSelection]="true"
        [filters]="this.filters"
        *ngIf="!isSingleOption()"
      ></app-filter-container>

      <app-header *ngIf="isSingleOption()">{{
          t(chipContents[0].filterType || '')
        }}</app-header>
    </div>

    <div class="port-batch-heading">
    <div class="port-batch-queue-area">
      <app-header>
        {{ t(labels.portBatchProcessing) }}
      </app-header>
      <app-icon-button v2 icon="play_circle_outline"
        [disabled]="true"
        (clickAction)="triggerPortPointsProcessing()">
        {{ portProcessing ? t(labels.portProcessingInProgress) : t(labels.triggerPortProcessing)
        }}
      </app-icon-button>
    </div>
      <div class="upload-queue-wrapper">
        <app-port-points-execution-head
          (downloadReport)="downloadPortBatchReport($event)"
          (processingChange)="updatePortProcessingState($event)"
        >
        </app-port-points-execution-head>
      </div>
    </div>
  </div>
</div>
